export type SortBy<T = string> = { id: T; desc: boolean };

export type PaginationOptionsType = {
  currentPage: number;
  entriesPerPage: number;
};

export type HandleChangePageMethod = (_: React.MouseEvent<HTMLElement> | null, page: number) => void;

export type HandleSortMethod<Column = string> = (columnId: Column, isSorted: boolean, isSortedDesc?: boolean) => void;

export type UsePagination = {
  paginationOptions: PaginationOptionsType;
  handleEntriesPerPage: (newValue: string) => void;
  handleChangePage: HandleChangePageMethod;
  setCurrentPage: (currentPage: number) => void;
};

export type UseBaseTableFilters<Sort = string> = UsePagination & {
  sortBy: SortBy<Sort>[];
  searchValue?: string;
  handleSearch: (newValue: string) => void;
  handleSort: HandleSortMethod<Sort>;
  resetFilters: () => void;
};

export type ExportablePaginationFields = Pick<
  UsePagination,
  'paginationOptions' | 'handleEntriesPerPage' | 'handleChangePage'
>;

export type ExportableTableFilters<Sort = string> = ExportablePaginationFields &
  Pick<UseBaseTableFilters<Sort>, 'sortBy' | 'handleSearch' | 'handleSort'>;

export enum PaginationStorageKey {
  currentPage = 'currentPage',
  entriesPerPage = 'entriesPerPage',
}

export type PaginationStorage = {
  [PaginationStorageKey.currentPage]?: number;
  [PaginationStorageKey.entriesPerPage]?: number;
};

export enum BaseTableFilterStorageKey {
  searchValue = 'searchValue',
  sortBy = 'sortBy',
}

export type BaseTableFilterStorage<Sort = string> = PaginationStorage & {
  [BaseTableFilterStorageKey.searchValue]?: string;
  [BaseTableFilterStorageKey.sortBy]?: SortBy<Sort>[];
};
